import React, { useEffect, useState } from 'react';
import { Input, InputNumber } from 'antd';
import PropTypes from 'prop-types';
import { isEmpty, isNaN, isNil } from 'lodash';

import { currencyFormatter, numberInputFormatter, numberInputParser, percentageFormatter } from 'utils';
import { Label, InfoMessage } from 'components';
import { useSelector } from 'react-redux';
import CurrencyInput from 'react-currency-input-field';

const NumberFieldWithDecimals = ({
  label,
  containerClassName,
  percentage = false,
  simple = false,
  currency = false,
  value,
  onChange,
  infoMessage,
  infoMessageClassName,
  autoFormat,
  className,
  asterisk = false,
  ...rest
}) => {

   const [formattedValue,setFormattedValue] = useState();
   const [realValue,setRealValue] = useState();
   
   const formatNumber = (value) =>{
     //console.log(value)
     if(!isEmpty(value)){
     if(isNaN(value)){
      if(currency){
        setFormattedValue(currencyFormatter(value))
      }else if(percentage){
        setFormattedValue(percentageFormatter(value))
      }else{
        setFormattedValue(value)
      }
      if(value){
       setRealValue(value)
      }
    }else{
      let temp = (value).replaceAll(',','.')
      temp=parseFloat(temp)
      if(currency){
        setFormattedValue(currencyFormatter(temp))
      }else if(percentage){
        setFormattedValue(percentageFormatter(temp))
      }else{
        setFormattedValue(temp)
      }
      if(temp){
       setRealValue(temp)
      }
    }
  }
   }

   const checkInput = (v)=>{
     onChange(v.target.value)
     let temp = (v.target.value).replaceAll(',','.')
     //console.log(parseFloat(temp))
     //setFormattedValue(parseFloat(temp))
     value=parseFloat(temp)

   }

   const viewMode =  useSelector(state => state.forms.carrier.viewMode);


  return (
    <div className={containerClassName || ''}>
      <div className="d-flex">
        <Label label={label} asterisk={asterisk} />
        <InfoMessage
          infoMessage={infoMessage}
          overlayClassName={infoMessageClassName}
        />
      </div>
      {/* <Input
        {...rest}
        onChange={v=> checkInput(v)}
        value={viewMode && formattedValue && !autoFormat ? (isNaN(formattedValue)? currencyFormatter(formattedValue.replaceAll(',','.')):currencyFormatter(parseFloat(formattedValue.replaceAll(',','.')))):formattedValue}
        onBlur={v=> autoFormat == false || isNil(autoFormat) ? formatNumber(v.target.value):''}
        onClick={()=>autoFormat == false || isNil(autoFormat) ? setFormattedValue(realValue):''}
      /> */}
      
      <CurrencyInput className='ant-input ant-input-lg'
        id="input-example"
        name="input-name"
        decimalsLimit={rest.decimalsLimit} // Limit length of decimals allowed
        decimalScale={rest.decimalScale} // Specify decimal scale for padding/trimming eg. 1.5 -> 1.50
        fixedDecimalLength={rest.fixedDecimalLength} // Value will always have the specified length of decimals
        allowNegativeValue={false} 
        value={value}
        groupSeparator={'.'}
        decimalSeparator={','}
        onValueChange={(value, name) =>onChange(value)}
        //suffix={''}
        placeholder={rest.placeholder}
        disabled={rest.disabled}
        />

    </div>
  );
};

NumberFieldWithDecimals.propTypes = {
  label: PropTypes.string.isRequired,
  containerClassName: PropTypes.string,
  value: PropTypes.number.isRequired,
  percentage: PropTypes.bool,
  simple: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

export default NumberFieldWithDecimals;
